// extracted by mini-css-extract-plugin
module.exports = {"container":"NivåFilter_container__a0mBA"};